import {useDisclosure} from '@mantine/hooks';
import {useAuth} from '../../../../core/usecases/useAuth';
import {FavoriteButton} from '../../../../shared/components/FavoriteButton';
import {NoLoginAlertModal} from '../../../../shared/components/NoLoginAlertModal';

type Props = {
  isClipped: boolean;
  clipCount: number;
  handleClip: () => Promise<void>;
};

export const ColumnClipButton: React.FC<Props> = ({
  isClipped,
  clipCount,
  handleClip,
}) => {
  const {isSignedIn} = useAuth();
  const [opened, {open, close}] = useDisclosure(false);

  const handleUpdate = async () => {
    if (!isSignedIn) {
      open();
      return;
    }

    await handleClip();
  };

  return (
    <>
      <FavoriteButton
        count={`${clipCount}`}
        isClipped={isClipped}
        handleUpdate={handleUpdate}
      />
      <NoLoginAlertModal opened={opened} onClose={close} />
    </>
  );
};
